<template>
    <el-tabs
        type="border-card"
        class="edutalk-information-tabs"
        v-model="activeTab"
        @tab-click="handleTabClick"
    >
        <el-tab-pane label="Thông tin chung" name="general">
            <div class="row edutalk-information-layout">
                <div class="col-12 col-lg-8 edutalk-information-main">
                    <edutalk-information-general></edutalk-information-general>
                </div>
                <div class="col-12 col-lg-4 edutalk-information-sidebar">
                    <edutalk-bank></edutalk-bank>
                    <edutalk-pancake v-if="is_sale && active_information"></edutalk-pancake>
                </div>
            </div>
        </el-tab-pane>

        <el-tab-pane label="Thông tin làm việc chung" name="working-info">
            <general-working-info></general-working-info>
        </el-tab-pane>

        <el-tab-pane label="Hợp đồng" name="contracts">
            <contracts></contracts>
        </el-tab-pane>

        <el-tab-pane label="Quá trình làm việc" name="working-process">
            <working-process></working-process>
        </el-tab-pane>

        <el-tab-pane label="Khung năng lực" name="capacity">
            Task
        </el-tab-pane>

        <el-tab-pane label="Phúc lợi" name="welfare">
            <welfare></welfare>
        </el-tab-pane>

        <el-tab-pane label="KPI" name="kpi">
            <kpi-staff></kpi-staff>
        </el-tab-pane>

        <el-tab-pane label="Ảnh và hồ sơ đính kèm" name="attachments">
            <photos-and-documents></photos-and-documents>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import CodeInput from "vue-verification-code-input";
import VueCountdown from '@chenfengyuan/vue-countdown';
import {mechanisms, mechanisms2} from "@/core/config/mechanism";
import EdutalkInformationGeneral from "./edutalk-information-general.vue";
import EdutalkBank from "./edutalk-brank.vue";
import GeneralWorkingInfo from "./components/GeneralWorkingInfo";
import WorkingProcess from "./components/WorkingProcess";
import Welfare from "./components/Welfare";
import JwtService from "@/core/services/jwt.service";
import Contracts from "./components/Contracts";
import PhotosAndDocuments from "./components/PhotosAndDocuments";
import KpiStaff from "./components/KpiStaff";
import EdutalkPancake from "./edutalk-pancake";

export default {
    name: "EdutalkInformation",
    components: {
        EdutalkBank,
        EdutalkInformationGeneral,
        CodeInput,
        VueCountdown,
        GeneralWorkingInfo,
        WorkingProcess,
        Welfare,
        Contracts,
        PhotosAndDocuments,
        KpiStaff,
        EdutalkPancake
    },
    props: {
        confirming: Boolean,
    },
    data() {
        return {
            activeTab: 'general',
            validTabs: [
                'general',
                'working-info',
                'contracts',
                'working-process',
                'capacity',
                'welfare',
                'kpi',
                'attachments'
            ],
            is_sale : false,
            active_information : true,
        };
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser'])
    },
    mounted() {
        if (this.currentUser.profile.candidate && this.currentUser.profile?.candidate.status == 3) {
            this.active_information = false;
        }
        let role_id = this.currentUser?.account_type?.id;
        if(role_id == '1' || role_id == '2' || role_id == '3' || role_id == '4') {
            this.is_sale = true;
        }
        const tabFromRoute = this.$route.query.tab;
        this.setTabFromRoute(tabFromRoute);

    },
    watch: {
        '$route.query.tab'(newVal) {
            this.setTabFromRoute(newVal);
        }
    },
    methods: {
        setTabFromRoute(tabName) {
            if (this.validTabs.includes(tabName)) {
                this.activeTab = tabName;
            } else {
                this.activeTab = 'general';
            }
        },
        handleTabClick(tab) {
            this.updateRoute(tab.name);
        },
        updateRoute(tabName) {
            const currentTab = this.$route.query.tab;
            if (currentTab === tabName) return;

            this.$router.push({
                query: {
                    ...this.$route.query,
                    tab: tabName
                }
            });
        }
    }
};
</script>

<style scoped>
.edutalk-information-tabs {
    width: 100%;
}

.edutalk-information-layout {
    min-width: 0;
}

.edutalk-information-main,
.edutalk-information-sidebar {
    min-width: 0;
}

.edutalk-information-tabs /deep/ .el-tabs__header {
    overflow: hidden;
}

.edutalk-information-tabs /deep/ .el-tabs__nav-wrap {
    overflow: hidden;
}

.edutalk-information-tabs /deep/ .el-tabs__nav-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
}

.edutalk-information-tabs /deep/ .el-tabs__nav {
    white-space: nowrap;
}

.edutalk-information-tabs /deep/ .el-tabs__item {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (max-width: 991.98px) {
    .edutalk-information-sidebar {
        margin-top: 16px;
    }

    .edutalk-information-tabs.el-tabs--border-card {
        border-left: 0;
        border-right: 0;
        box-shadow: none;
    }

    .edutalk-information-tabs /deep/ .el-tabs__content {
        padding: 12px;
    }
}

@media (max-width: 575.98px) {
    .edutalk-information-tabs /deep/ .el-tabs__content {
        padding: 10px 0;
    }

    .edutalk-information-tabs /deep/ .el-tabs__item {
        max-width: 180px;
        padding: 0 12px;
        font-size: 13px;
    }
}
</style>
